import React from 'react'
import { navigate } from 'gatsby-link'
import classnames from 'classnames'
import { graphql } from 'gatsby'

import PageComponent from '../../../util/page-component'

import Container from '../../Container'
import FocusBox from '../../FocusBox'
import Icon from '../../Icon'
import InnerHtmlHelper from '../../InnerHtmlHelper'
import Link from '../../Link'
import PageTitle from '../../PageTitle'
import { Column, Row } from '../../Grid'

import styles from './index.module.scss'
import { align } from '../../../core/styles'
import { ether, mg } from '../../../core'
import Layout from '../../Layout'

class JoinPage extends PageComponent {
  constructor() {
    super()
    this.state = {}
  }

  componentWillMount() {
    const { pageContext: { identifier } } = this.props
    const { data: { page: { categories } } } = this.props
    const category = categories.filter(category => category.identifier === identifier).pop()
    this.category = category
  }

  componentDidMount() {
    const { pageContext: { planPath } } = this.props
    const existing = planPath.indexOf('existing') !== -1
    if (existing) {
      // No plan selection for existing memberships. Redirect to the join page for the first pricing.
      const { pricing: { pricings: [ pricing ] } } = this.category
      navigate(`${planPath}${pricing.identifier}/`)
    }
  }

  render () {
    const { data, pageContext, location } = this.props
    const { planPath } = pageContext
    const { page } = data
    const { sectionTitle, heading } = page

    const category = this.category
    const { pricing } = category
    const { pricings } = pricing

    return (
      <Layout page={data.page} location={location} noDistraction="green">
        <div className={ classnames(styles.joinpage, ether('p-y-spacer-2xl')) }>
          { this.helmet(page) }
          <Container>
            <Container size="sm">
              <PageTitle section={ sectionTitle ? sectionTitle : '' }>{ heading || sectionTitle }</PageTitle>
              <InnerHtmlHelper html={ pricing.subheading } />
            </Container>

              {
                pricings ? (
                  <Row className={ ether('m-y-spacer-xl') } misc={['bottom-xs', 'center-xs', 'row-gutter-xl']}>
                    {
                      pricings.map(pricing => (
                        <Column key={ pricing.name } size={{ md: 4 }}>
                          <Container size="xs" className={ ether('m-b-spacer-md') }>
                            <FocusBox heading={ pricing.recommended ? 'Recommended' : pricing.heading } color={ pricing.recommended ? 'green' : pricing.heading ? 'cyan' : null }>
                              <h5><Icon size="sm" name={ pricing.icon.identifier }/></h5>
                              <h6>{ pricing.name }</h6>
                              <InnerHtmlHelper html={ pricing.pricingDetails } />
                              { pricing.action && pricing.action.map((action, index) => (
                                <div key={ action.id } className={ ether('m-y-spacer-md') }>
                                  {/* This is somewhat brittle, as it uses the action name to determine the term. */}
                                  <Link to={ action.actionUrl || `${planPath}${pricing.identifier}/${action.actionName.toLowerCase().indexOf('month') > -1 ? 'month' : 'year'}` } className={ mg('button', 'button-mixed', 'button-width-md', index < pricing.action.length - 1 && 'button-outline') }>
                                    { action.actionName }
                                  </Link>
                                </div>
                              )) }
                            </FocusBox>
                          </Container>
                        </Column>
                      ))
                    }
                  </Row>
                ) : null
              }

            <div className={ classnames(styles.finePrint, align.center, ether('m-y-spacer-xl', 'fine-print')) }>
              * <InnerHtmlHelper html={ pricing.finePrint } />
            </div>
          </Container>
        </div>
      </Layout>
    )
  }
}

export default JoinPage

export const query = graphql`
  query PageJoinPlanByPath($joinPath: String!) {
    page: contentfulPageJoin(path: {eq: $joinPath }) {
      path
      seoTitle
      seoDescription
      sectionTitle
      heading
      categories {
        id
        identifier
        icon {
          identifier
        }
        title
        body {
          childMarkdownRemark {
            html
          }
        }
        pricing {
          subheading {
            childMarkdownRemark {
              html
            }
          }
          pricings {
            identifier
            icon {
              identifier
            }
            heading
            name
            pricingDetails {
              childMarkdownRemark {
                html
              }
            }
            recommended
            action {
              id
              actionName
              actionUrl
            }
          }
          finePrint {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
